import type { ProjectData } from "../types/project";
import { PORTFOLIO_LINKS } from "./portfolio";
import { SiliconPlanOverlay } from "@/components/generic/siliconPlanOverlay";

import artstakeAsset1 from "@/assets/images/portfolioSlider/artstakeAsset1.webp";
import artstakeAsset2 from "@/assets/images/portfolioSlider/artstakeAsset2.webp";
import artstakeAsset3 from "@/assets/images/portfolioSlider/artstakeAsset3.webp";
import colichainAsset1 from "@/assets/images/portfolioSlider/colichainAsset1.webp";
import colichainAsset2 from "@/assets/images/portfolioSlider/colichainAsset2.webp";
import colichainBG from "@/assets/images/portfolioSlider/colichainBG.webp";
import coliseumAsset from "@/assets/images/portfolioSlider/coliseumAsset.webp";
import coliseumBG from "@/assets/images/portfolioSlider/coliseumBG.webp";
import connectionsAiAsset from "@/assets/images/portfolioSlider/connectionsAiAsset.webp";
import connectionsAiBG from "@/assets/images/portfolioSlider/connectionsAiBG.webp";
import ctrlshiftAsset1 from "@/assets/images/portfolioSlider/ctrlshiftAsset1.webp";
import ctrlshiftAsset2 from "@/assets/images/portfolioSlider/ctrlshiftAsset2.webp";
import ctrlshiftBG from "@/assets/images/portfolioSlider/ctrlshiftBG.webp";
import drugRepAsset1 from "@/assets/images/portfolioSlider/drugRepAsset1.webp";
import drugRepAsset2 from "@/assets/images/portfolioSlider/drugRepAsset2.webp";
import drugRepBG from "@/assets/images/portfolioSlider/drugRepBG.webp";
import fractionnaireBG from "@/assets/images/portfolioSlider/farctionnaireBG.webp";
import fractionnaireAsset from "@/assets/images/portfolioSlider/fractionnaireAsset1.webp";
import giordanoRispoAsset from "@/assets/images/portfolioSlider/giordanoRispoAsset.webp";
import giordanoRispoBG from "@/assets/images/portfolioSlider/giordanoRispoBG.webp";
import modusAsset from "@/assets/images/portfolioSlider/modusAsset.webp";
import modusBG from "@/assets/images/portfolioSlider/modusBG.webp";
import morningsideAsset from "@/assets/images/portfolioSlider/morningsideAsset.webp";
import morningsideBG from "@/assets/images/portfolioSlider/morningsideBG.webp";
import napulethBG from "@/assets/images/napulethBG.webp";
import napulethComet from "@/assets/images/napulethComet.webp";
import napulethDiamond from "@/assets/images/napulethDiamond.webp";
import napulethPlanet from "@/assets/images/napulethPlanet.webp";
import napulethScreen from "@/assets/images/napulETHScreen.webp";
import nexAsset1 from "@/assets/images/nexAsset11.webp";
import nexAsset2 from "@/assets/images/nexAsset2.webp";
import nmkCreativeHubAsset from "@/assets/images/portfolioSlider/nmkCreativeHubAsset.webp";
import nmkCreativeHubBG from "@/assets/images/portfolioSlider/nmkCreativeHubBG.webp";
import quantumComplianceBG from "@/assets/images/portfolioSlider/quantumComplianceBG.webp";
import quantumCustodyAsset1 from "@/assets/images/portfolioSlider/quantumCustodyAsset1.webp";
import quantumCustodyAsset2 from "@/assets/images/portfolioSlider/quantumCustodyAsset2.webp";
import quantumCustodyBG from "@/assets/images/portfolioSlider/quantumCustodyBG.webp";
import rumooAsset1 from "@/assets/images/portfolioSlider/rumooAsset1.webp";
import rumooAsset2 from "@/assets/images/portfolioSlider/rumooAsset2.webp";
import rumooBG from "@/assets/images/portfolioSlider/rumooBG.webp";
import siliconPlanAsset from "@/assets/images/portfolioSlider/siliconPlanAsset.webp";
import siliconPlanBG from "@/assets/images/portfolioSlider/siliconPlanBG.webp";
import sitelabAsset1 from "@/assets/images/portfolioSlider/sitelabAsset1.webp";
import sitelabAsset2 from "@/assets/images/portfolioSlider/sitelabAsset2.webp";
import spyralAsset from "@/assets/images/portfolioSlider/spyralAsset.webp";
import spyralBG from "@/assets/images/portfolioSlider/spyralBG.webp";
import trustifyAsset from "@/assets/images/portfolioSlider/trustifyAsset.webp";
import trustifyBG from "@/assets/images/portfolioSlider/trustifyBG.webp";
import ukgovAsset1 from "@/assets/images/portfolioSlider/ukgovAsset1.webp";
import ukgovAsset2 from "@/assets/images/portfolioSlider/ukgovAsset2.webp";
import ukgovBG from "@/assets/images/portfolioSlider/ukgovBG.webp";
import unicoverAsset1 from "@/assets/images/portfolioSlider/unicoverAsset1.webp";
import unicoverAsset2 from "@/assets/images/portfolioSlider/unicoverAsset2.webp";
import unicoverBG from "@/assets/images/portfolioSlider/unicoverBG.webp";
import uranoAsset1 from "@/assets/images/portfolioSlider/uranoAsset1.webp";
import uranoAsset2 from "@/assets/images/portfolioSlider/uranoAsset2.webp";
import uranoBG from "@/assets/images/portfolioSlider/uranoBG.webp";
import wishinwellAsset from "@/assets/images/portfolioSlider/wishinwellAsset.webp";
import wishinwellBG from "@/assets/images/portfolioSlider/wishinwellBG.webp";

export const projectsData: ProjectData[] = [
  {
    id: "nex",
    title: "NEX",
    subtitle: "Decentralized Exchange",
    link: PORTFOLIO_LINKS.nexlabs,
    background:
      "linear-gradient(#121B19, #121B19) padding-box, linear-gradient(286.36deg, rgba(255,255,255,0.15) 0.54%, rgba(255,255,255,0) 96.68%) border-box",
    titleColor: "#00FFD1",
    subtitleColor: "#FFFFFF",
    titleShadow: "0px 0px 10px rgba(0,255,209,0.35)",
    rootSx: {
      border: "1.09px solid transparent",
      backgroundClip: "padding-box, border-box",
      "& .nex-asset-1": {
        transform: "scale(1)",
        transition: "transform 0.3s ease-in-out",
      },
      "& .nex-asset-2": {
        filter: "brightness(0.35)",
        transition: "filter 0.3s ease-in-out",
      },
      "&:hover .nex-asset-1": {
        transform: "scale(1.05)",
      },
      "&:hover .nex-asset-2": {
        filter: "brightness(1)",
      },
    },
    assets: [
      {
        decorClass: "nex-asset-1",
        src: nexAsset1,
        alt: "NEX app screen",
        width: { xs: "50%", sm: "30%", md: "25%", lg: "40%", xl: "28%" },
        zIndex: 4,
        position: { right: "3%", bottom: "-30%" },
        transition: "transform 0.3s ease-in-out",
        hoverTransform: "scale(1.05)",
      },
      {
        decorClass: "nex-asset-2",
        src: nexAsset2,
        alt: "NEX decorative blur",
        width: { xs: "86%", sm: "66%", md: "70%", lg: "70%", xl: "70%"  },
        zIndex: 2,
        position: { left: "0%", bottom: "-10%" },
        transition: "filter 0.3s ease-in-out",
        hoverTransform: "scale(1)",
      },
    ],
  },
  {
    id: "napuleth",
    title: "NAPULETH",
    subtitle: "Web 3 Event Website",
    link: PORTFOLIO_LINKS.napuleth,
    background: "linear-gradient(130deg, #1D1628 0%, #0D1021 100%)",
    bgImage: napulethBG,
    bgImageClassName: "napuleth-bg",
    bgImageOpacity: 0.78,
    titleColor: "#DB89FF",
    subtitleColor: "#78D0F3",
    titleShadow: "0px 0px 8px #DB89FF",
    rootSx: {
      "& .napuleth-bg": {
        transition: "opacity 0.3s ease-in-out, filter 0.3s ease-in-out",
      },
      "&:hover .napuleth-bg": {
        opacity: 1,
        filter: "brightness(1.1)",
      },
      "& .nap-screen": {
        transform: "scale(1)",
        transition: "transform 0.3s 0.15s ease-in-out",
      },
      "&:hover .nap-screen": {
        transform: "scale(1.035)",
      },
      "& .nap-orb-1": {
        transform: "scale(1)",
        transition: "transform 0.3s 0.1s ease-in-out",
      },
      "&:hover .nap-orb-1": {
        transform: "scale(1.2)",
      },
      "& .nap-orb-2": {
        transition: "top 0.3s 0.1s ease-in-out",
      },
      "&:hover .nap-orb-2": {
        top: "55%",
      },
      "& .nap-comet": {
        transition: "top 0.3s 0.1s ease-in-out",
      },
      "&:hover .nap-comet": {
        top: "35%",
      },
    },
    assets: [
      {
        decorClass: "nap-screen",
        src: napulethScreen,
        alt: "Napuleth screen",
        width: { xs: "80%", sm: "80%", md: "70%", lg: "70%", xl: "70%" },
        zIndex: 4,
        position: { left: { xs: "10%", sm: "10%", md: "10%", lg: "10%", xl: "20%" }, top: { xs: "35%", sm: "40%", md: "40%", lg: "40%", xl: "10%" } },
        transition: "transform 0.3s 0.15s ease-in-out",
        hoverTransform: "scale(1.035)",
      },
      {
        decorClass: "nap-orb-1",
        src: napulethPlanet,
        alt: "Napuleth planet large",
        width: { xs: "16%", md: "14%" },
        zIndex: 5,
        position: { left: { xs: "3%", md: "2%" }, bottom: { xs: "22%", md: "10%" } },
        transition: "transform 0.3s 0.1s ease-in-out",
        hoverTransform: "scale(1.2)",
      },
      {
        decorClass: "nap-orb-2",
        src: napulethPlanet,
        alt: "Napuleth planet small",
        width: { xs: "10%", md: "9%" },
        zIndex: 5,
        position: { right: { xs: "3%", md: "101%" }, top: { xs: "50%", md: "50%" } },
        transition: "top 0.3s 0.1s ease-in-out",
        hoverTransform: "translateY(6%)",
      },
      {
        decorClass: "nap-comet",
        src: napulethComet,
        alt: "Napuleth comet",
        width: { xs: "16%", md: "14%" },
        zIndex: 4,
        position: { left: { xs: "0%", md: "2%" }, top: { xs: "35%", md: "35%" } },
        transition: "top 0.3s 0.1s ease-in-out",
        hoverTransform: "translateY(-10%)",
      },
      {
        src: napulethDiamond,
        alt: "Napuleth diamond 1",
        width: { xs: "18%", md: "16%" },
        zIndex: 5,
        position: { right: { xs: "2%", md: "5%" }, bottom: { xs: "10%", md: "10%" } },
        transition: "bottom 0.3s 0.1s ease-in-out",
        hoverTransform: "translateY(-6%)",
      },
      {
        src: napulethDiamond,
        alt: "Napuleth diamond 2",
        width: { xs: "10%", md: "9%" },
        zIndex: 5,
        position: { right: "18%", top: "25%" },
        idleTransform: "scaleX(-1) rotate(-20deg)",
        transition: "top 0.3s 0.1s ease-in-out",
        hoverTransform: "scaleX(-1) rotate(-20deg) translateY(8%)",
      },
      {
        src: napulethDiamond,
        alt: "Napuleth diamond 3",
        width: { xs: "7%", md: "6.5%" },
        zIndex: 5,
        position: { left: "40%", top: "15%" },
        transition: "top 0.3s 0.1s ease-in-out",
        hoverTransform: "translateY(8%)",
      },
    ],
  },
  {
    id: "colichain-l2",
    title: "Colichain",
    subtitle: "L2 Infrastructure for the Real-World Token Economy",
    link: PORTFOLIO_LINKS.colichainL2,
    background: "#111111",
    bgImage: colichainBG,
    bgImageObjectPosition: "right",
    titleGradient: "linear-gradient(90deg, #FF560A 0%, #FF850A 47.44%)",
    subtitleColor: "#212121",
    assets: [
      {
        src: colichainAsset1,
        alt: "Colichain",
        width: { xs: "120%", sm: "100%", md: "100%", lg: "100%", xl: "90%" }, 
        zIndex: 6,
        position: { right: "0%", bottom: "-20%" },
        idleTransform: "scale(1.2)",
        transition: "all 0.4s ease-in-out",
        hoverTransform: "translateY(-8px) scale(1.25)",
        hoverFilter: "brightness(1.08)",
      },
    ],
  },
  {
    id: "fractionnaire",
    title: "Fractionaire",
    subtitle: "Real Estate RWA Platform",
    link: PORTFOLIO_LINKS.fractionnaire,
    background: "#1a1510",
    bgImage: fractionnaireBG,
    bgImageOpacity: 0.7,
    titleColor: "#C6FF00",
    subtitleColor: "rgba(255,255,255,0.92)",
    assets: [
      {
        src: fractionnaireAsset,
        alt: "Fractionnaire",
        width: { xs: "120%", sm: "90%", md: "75%", lg: "100%", xl: "80%" }, 
        zIndex: 4,
        position: { right: "-3%", bottom: { xs: "-20%", sm: "-30%", md: "-35%" } },
        transition: "all 0.4s ease-in-out",
        hoverTransform: "translateY(-8px) scale(1.05)",
        hoverFilter: "brightness(1.08)",
      },
    ],
  },
  {
    id: "trustify",
    title: "Trustify",
    subtitle: "Restores trust in\nhigh-quality food products",
    link: PORTFOLIO_LINKS.trustify,
    background: "#0c0f0d",
    bgImage: trustifyBG,
    titleColor: "#C6FF00",
    subtitleColor: "#FFFFFF",
    assets: [
      {
        src: trustifyAsset,
        alt: "Trustify",
        width: { xs: "120%", sm: "90%", md: "100%", lg: "100%", xl: "90%" },
        zIndex: 4,
        position: { right: { xs: "-15%", sm: "-5%", md: "-5%", lg: "-5%", xl: "-5%" }, bottom: { xs: "-15%", sm:"-20%", md: "-20%", lg: "-20%", xl: "-35%" } },
        transition: "all 0.4s ease-in-out",
        hoverTransform: "translateY(-8px) scale(1.05)",
        hoverFilter: "brightness(1.08)",
      },
    ],
  },
  {
    id: "unicover",
    title: "Unicover",
    subtitle: "Insurance brokerage and\nrisk management services",
    link: PORTFOLIO_LINKS.unicover,
    background: "#eae8fc",
    bgImage: unicoverBG,
    titleColor: "#FFF",
    subtitleColor: "#FFF",
    assets: [
      {
        src: unicoverAsset1,
        alt: "Unicover",
        width: { xs: "60%", sm: "50%", md: "44%", lg: "50%", xl: "40%" },
        zIndex: 3,
        position: { left: "5%", bottom: { xs: "0%", sm: "-10%", md: "0%", lg: "0%", xl: "-15%" } },
        transition: "filter 0.3s ease, box-shadow 0.3s ease",
        hoverTransform: "translateY(-4px)",
        hoverFilter:
          "drop-shadow(0px 4px 31.6px rgba(255, 255, 255, 0.35)) brightness(1.05)",
      },
      {
        src: unicoverAsset2,
        alt: "Unicover-secondary",
        width: { xs: "150%", sm: "100%", md: "92%", lg: "92%", xl: "80%" },
        zIndex: 5,
        position: { right: { xs: "-48%", sm: "-18%", md: "-18%", xl: "-5%" }, bottom: { xs: "-55%", sm: "-50%", md: "-45%", lg: "-45%", xl: "-55%" } },
        idleTransform: "scale(1)",
        transition: "transform 0.3s ease, bottom 0.3s ease",
        hoverTransform: "translateY(-8px) scale(1.1)",
        hoverFilter: "brightness(1.05)",
      },
    ],
  },
  {
    id: "spyral",
    title: "Spyral",
    subtitle: "Blockchain music\nrights & royalties",
    link: PORTFOLIO_LINKS.spyral,
    background: "#0b0014",
    bgImage: spyralBG,
    bgImageOpacity: 0.7,
    titleColor: "#06D5FF",
    subtitleColor: "#FFFFFF",
    assets: [
      {
        src: spyralAsset,
        alt: "Spyral",
        width: { xs: "130%", sm: "100%", md: "85%", lg: "120%", xl: "100%" },
        zIndex: 4,
        position: { right: { xs: "-15%", md: "-5%", lg: "-14%", xl: "-14%" }, bottom: { xs: "-11%", sm: "-15%", md: "-20%", lg: "-20%", xl: "-30%" } },
        transition: "filter 0.3s ease, box-shadow 0.3s ease",
        hoverTransform: "translateY(-4px)",
        hoverFilter:
          "drop-shadow(0px 4px 31.6px rgba(255, 255, 255, 0.35)) brightness(1.05)",
      },
    ],
  },
  {
    id: "morningside",
    title: "Morningside",
    subtitle: "AI Consulting\nand Dev Firm",
    link: PORTFOLIO_LINKS.morningside,
    background: "#050810",
    bgImage: morningsideBG,
    bgImageOpacity: 0.7,
    titleColor: "#31D484",
    subtitleColor: "#FFFFFF",
    assets: [
      {
        src: morningsideAsset,
        alt: "Morningside",
        width: { xs: "125%", sm: "100%", md: "100%" },
        zIndex: 4,
        position: { left: { xs: "-20%", sm: "-5%", md: "-5%" }, right: "0%", bottom: { xs: "-60%", sm:"-75%", md: "-60%", lg: "-60%", xl: "-95%" } },
        transition: "filter 0.3s ease, box-shadow 0.3s ease",
        hoverTransform: "translateY(-4px)",
        hoverFilter:
          "drop-shadow(0px 4px 31.6px rgba(255, 255, 255, 0.35)) brightness(1.05)",
      },
    ],
  },
  {
    id: "coliseum-dex",
    title: "Coliseum DEX",
    subtitle: "Seamless Cross-Chain Swaps",
    link: PORTFOLIO_LINKS.coliseumDex,
    background: "#080d22",
    bgImage: coliseumBG,
    bgImageObjectPosition: "right",
    titleGradient: "linear-gradient(90deg, #396ADD 0%, #6B9CFF 100%)",
    subtitleColor: "#4994EC",
    assets: [
      {
        src: coliseumAsset,
        alt: "Coliseum",
        width: "110%",
        zIndex: 6,
        position: { right: "-2%", top: { xs: "67%", sm: "45%", md: "38%", lg: "50%" } },
        transition: "top 0.3s ease, transform 0.3s ease",
        hoverTransform: "translateY(+6px)",
        hoverFilter: "brightness(1.06)",
      },
    ],
  },
  {
    id: "ctrlshift",
    title: "ctrlshift",
    subtitle: "world-class summit",
    link: PORTFOLIO_LINKS.ctrlshift,
    background: "#9b2627",
    bgImage: ctrlshiftBG,
    titleColor: "#FFE033",
    subtitleColor: "#FFFFFF",
    assets: [
      {
        src: ctrlshiftAsset1,
        alt: "ctrlshift-1",
        width: { xs: "78%", sm: "68%", md: "60%", lg: "80%", xl: "70%" },
        zIndex: 4,
        position: { left: { xs: "-5%", sm: "8%", md: "18%", lg: "10%", xl: "10%" }, bottom: { xs: "8%", sm: "-8%", md: "-10%", lg: "-10%", xl: "-15%" } },
        transition: "transform 0.3s ease",
        hoverTransform: "scale(1.05)",
        hoverFilter:
          "drop-shadow(0px 4px 31.6px rgba(255, 255, 255, 0.28)) brightness(1.05)",
      },
      {
        src: ctrlshiftAsset2,
        alt: "ctrlshift-2",
        width: { xs: "38%", sm: "28%", md: "22%", lg: "32%", xl: "25%" },
        zIndex: 5,
        position: { right: { xs: "-2%", sm: "-2%", md: "-2%", lg: "-2%", xl: "-2%" }, bottom: { xs: "8%", sm: "0%", md: "-8%", lg: "2%", xl: "-5%" } },
        idleTransform: "scale(1.85)",
        transition: "transform 0.3s ease",
        hoverTransform: "scale(1.9)",
        hoverFilter: "brightness(1.05)",
      },
    ],
  },
  {
    id: "colichain-marketplace",
    title: "Colichain",
    subtitle: "L2 Infrastructure for RWA",
    link: PORTFOLIO_LINKS.colichainMarketplace,
    background: "#111111",
    bgImage: colichainBG,
    bgImageObjectPosition: "right",
    titleGradient: "linear-gradient(90deg, #FF560A 0%, #FF850A 47.44%)",
    subtitleColor: "#212121",
    assets: [
      {
        src: colichainAsset2,
        alt: "Colichain marketplace",
        width: { xs: "130%", md: "100%" },
        zIndex: 6,
        position: { right: { xs: "-18%", md: "-10%" }, bottom: "0%" },
        idleTransform: "scale(1.2)",
        transition: "all 0.4s ease-in-out",
        hoverTransform: "translateY(-6px) scale(1.25)",
        hoverFilter: "brightness(1.06)",
      },
    ],
  },
  {
    id: "sitelab",
    title: "sitelab",
    subtitle: "AI Site Builder",
    link: PORTFOLIO_LINKS.sitelab,
    background: "linear-gradient(180deg, #141415 0%, rgba(198, 198, 201, 0.4) 100%)",
    titleShadow: "0 2px 10px rgba(0,0,0,0.5)",
    titleColor: "#FFFFFF",
    subtitleColor: "#1ABBFF",
    assets: [
      {
        src: sitelabAsset1,
        alt: "sitelab-main",
        width: { xs: "80%", sm: "65%", md: "62%", lg: "58%", xl: "50%" },
        zIndex: 7,
        position: {
          left: { xs: "-10%", sm: "5%", md: "2%", lg: "5%" },
          bottom: { xs: "-10%", sm: "-12%", md: "-14%", lg: "-12%", xl: "-15%" },
        },
        transition: "all 0.4s ease",
        hoverTransform: "translateY(-5px) scale(1)",
        hoverFilter:
          "brightness(1.2) drop-shadow(0px 0px 20px rgba(169, 134, 251, 0.4))",
      },
      {
        src: sitelabAsset2,
        alt: "sitelab-secondary",
        width: { xs: "80%", sm: "60%", md: "74%", lg: "70%", xl: "55%" },
        zIndex: 8,
        position: {
          right: { xs: "-20%", sm: "-8%", md: "-12%", lg: "-10%", xl: "5%" },
          bottom: { xs: "-20%", sm: "-35%", md: "-34%", lg: "-30%", xl: "-62%" },
        },
        transition: "all 0.5s ease",
        hoverTransform: "translateY(-5px) scale(1)",
        hoverFilter:
          "brightness(1.2) drop-shadow(0px 0px 15px rgba(255, 255, 255, 0.3))",
      },
    ],
  },
  {
    id: "urano",
    title: "urano",
    subtitle: "On-chain tokenization",
    link: PORTFOLIO_LINKS.urano,
    background: "#000000",
    bgImage: uranoBG,
    bgImageOpacity: 0.82,
    titleColor: "#63C9C1",
    titleShadow: "0px 0px 10px rgba(255, 224, 51, 0.4)",
    subtitleColor: "#FFFFFF",
    assets: [
      {
        src: uranoAsset1,
        alt: "urano-1",
        width: { xs: "40%", sm: "28%", md: "23%", lg: "32%", xl: "28%" },
        zIndex: 5,
        position: { left: "-4%", bottom: "-12%" },
        transition: "transform 0.5s ease",
        hoverTransform: "translateY(-10px) rotate(-5deg)",
        hoverFilter: "brightness(1.08)",
      },
      {
        src: uranoAsset2,
        alt: "urano-2",
        width: { xs: "40%", sm: "28%", md: "23%", lg: "32%", xl: "28%" },
        zIndex: 7,
        position: { left: "22%", bottom: "-16%" },
        transition: "transform 0.6s ease",
        hoverTransform: "translateY(-15px) rotate(5deg)",
        hoverFilter: "brightness(1.08)",
      },
    ],
  },
  {
    id: "siliconplan",
    title: "siliconplan",
    subtitle: "AI-Powered\nPlatform for\nBusiness",
    link: PORTFOLIO_LINKS.siliconplan,
    background: "#000000",
    bgImage: siliconPlanBG,
    titleGradient: "linear-gradient(90deg, #4366D0 0%, #6C58AB 52.14%)",
    subtitleColor: "#001173",
    customOverlay: <SiliconPlanOverlay />,
    assets: [
      {
        decorClass: "silicon-plan-hero",
        src: siliconPlanAsset,
        alt: "siliconplan",
        width: { xs: "60%", sm: "42%", md: "37%", lg: "45%", xl: "40%" },
        zIndex: 6,
        position: { right: { xs: "0%", sm: "15%", md: "10%", lg: "10%", xl: "15%" }, bottom: { xs: "8px", sm: "5%" , md: "5%" , lg: "5%" } },
        idleTransform: "scale(1.2)",
        transition: "all 0.4s ease",
        hoverTransform: "translateY(-4px) scale(1.25)",
        hoverFilter: "brightness(1.06)",
      },
    ],
  },
  {
    id: "giordano-rispo",
    title: "giordano rispo",
    subtitle: "Photo Portfolio",
    link: PORTFOLIO_LINKS.giordanoRispo,
    background: "#000000",
    bgImage: giordanoRispoBG,
    bgImageOpacity: 0.62,
    titleColor: "#FFFFFF",
    titleShadow: "0 0 10px rgba(49, 212, 132, 0.5)",
    subtitleColor: "#D4D4D4",
    cardHoverTransform: "scale(1.02)",
    assets: [
      {
        src: giordanoRispoAsset,
        alt: "Giordano Rispo photo",
        width: { xs: "100%", sm: "90%", md: "90%", lg: "90%", xl: "70%" },
        zIndex: 4,
        position: { right: { xs: "-10%", sm: "-10%", md: "-10%", lg: "-10%", xl: "10%" }, bottom: { xs: "-5%", sm: "-20%", md: "-15%", lg: "-15%", xl: "-10%" } },
        transition: "all 0.4s ease-in-out",
        hoverTransform: "translateY(-12px) scale(1.05)",
        hoverFilter:
          "brightness(1.2) drop-shadow(0 0 15px rgba(255, 255, 255, 0.3))",
      },
    ],
  },
  {
    id: "uk-government",
    title: "uk government",
    subtitle: "Quantum Security Dashboard",
    link: PORTFOLIO_LINKS.ukGovernment,
    background: "#050c18",
    bgImage: ukgovBG,
    titleGradient: "linear-gradient(90deg, #4487FF 0%, #3CCED5 100%)",
    subtitleColor: "#FFFFFF",
    assets: [
      {
        src: ukgovAsset1,
        alt: "ukgov-1",
        width: { xs: "34%", md: "18%", lg: "30%" },
        zIndex: 5,
        position: { left: "10%", bottom: "34px" },
        idleTransform: "scale(1.3)",
        transition: "transform 0.3s ease",
        hoverTransform: "scale(1.35)",
        hoverFilter: "brightness(1.12)",
      },
      {
        src: ukgovAsset2,
        alt: "ukgov-2",
        width: { xs: "34%", md: "18%", lg: "30%" },
        zIndex: 6,
        position: { left: "60%", bottom: "34px" },
        idleTransform: "scale(1.3)",
        transition: "transform 0.3s ease",
        hoverTransform: "scale(1.35)",
        hoverFilter: "brightness(1.12)",
      },
    ],
  },
  {
    id: "quantum-compliance",
    title: "quantum compliance",
    subtitle: "Enterprise Landing Design",
    link: PORTFOLIO_LINKS.quantumCompliance,
    background: "linear-gradient(135deg, #0f1b3d 0%, #1e2d5e 55%, #070b14 100%)",
    bgImage: quantumComplianceBG,
    bgImageClassName: "quantumCompliance-bg",
    bgImageObjectPosition: "center",
    bgImageOpacity: 0.55,
    titleColor: "#FFFFFF",
    subtitleColor: "#D0E0FF",
    rootSx: {
      "& .quantumCompliance-bg": {
        marginTop: "20%",
        transform: "scale(2)",
        transition: "transform 0.3s ease",
      },
      "&:hover .quantumCompliance-bg": {
        transform: "scale(2.1)",
      },
    },
    assets: [],
  },
  {
    id: "rumoo",
    title: "rumoo",
    subtitle: "KOL Collaboration",
    link: PORTFOLIO_LINKS.rumoo,
    background:
      "linear-gradient(90deg, #c1c1f6 0%, rgba(158, 190, 245, 0.4) 100%)",
    bgImage: rumooBG,
    titleColor: "#0A605D",
    subtitleColor: "#0A605D",
    assets: [
      {
        src: rumooAsset1,
        alt: "rumoo-main",
        width: { xs: "68%", md: "68%", lg: "62%" },
        zIndex: 3,
        position: { left: { xs: "6%", sm: "6%", md: "10%" }, bottom: "-4px" },
        transition: "all 0.4s ease",
        hoverTransform: "translateY(-10px) scale(1.05)",
        hoverFilter:
          "brightness(1.2) drop-shadow(0px 0px 20px rgba(169, 134, 251, 0.4))",
      },
      {
        src: rumooAsset2,
        alt: "rumoo-secondary",
        width: { xs: "88%", sm: "68%", md: "78%", lg: "72%", xl: "58%" },
        zIndex: 6,
        position: { right: { xs: "-12%", sm: "-5%", md: "-8%", lg: "-6%", xl: "5%" }, bottom: { xs: "-58%", sm: "-90%", md: "-50%", lg: "-76%", xl: "-90%" } },
        transition: "all 0.5s ease",
        hoverTransform: "translateY(-6px) scale(1.04)",
        hoverFilter:
          "brightness(1.2) drop-shadow(0px 0px 15px rgba(255, 255, 255, 0.3))",
      },
    ],
  },
  {
    id: "modus",
    title: "Modus",
    subtitle: "RWA Platform",
    link: PORTFOLIO_LINKS.modus,
    background: "#080808",
    bgImage: modusBG,
    bgImageOpacity: 0.7,
    titleColor: "#FFFFFF",
    subtitleColor: "#FFFFFF",
    subtitleOpacity: 0.75,
    assets: [
      {
        src: modusAsset,
        alt: "Modus",
        width: { xs: "170%", sm: "140%", md: "120%", lg: "170%", xl: "120%" },
        zIndex: 4,
        position: { left: { xs: "-25%", sm: "-25%", md: "-5%", lg: "-25%", xl: "-5%" }, bottom: { xs: "-10%", sm: "-30%", md: "-40%", lg: "-30%", xl: "-30%" } },
        transition: "top 0.3s ease, transform 0.3s ease",
        hoverTransform: "translateY(-6px)",
        hoverFilter: "brightness(1.06)",
      },
    ],
  },
  {
    id: "quantum-custody",
    title: "quantumCustody",
    subtitle: "Precision-Driven Cryptographic Interface",
    link: PORTFOLIO_LINKS.quantumCustody,
    background: "#030014",
    bgImage: quantumCustodyBG,
    bgImageOpacity: 0.72,
    titleColor: "#A986FB",
    titleShadow: "0 2px 10px rgba(0,0,0,0.5)",
    subtitleColor: "#D4D4D4",
    assets: [
      {
        src: quantumCustodyAsset1,
        alt: "quantumCustody-1",
        width: { xs: "82%",  sm: "60%", md: "62%", lg: "62%", xl: "55%" },
        zIndex: 6,
        position: { left: { xs: "5%", md: "10%", lg: "5%", xl: "15%" }, bottom: { xs: "-12px", md: "-12px", lg: "-12px", xl: "-25px" } },
        transition: "all 0.4s ease",
        hoverTransform: "translateY(-10px) scale(1.05)",
        hoverFilter:
          "brightness(1.2) drop-shadow(0px 0px 20px rgba(169, 134, 251, 0.4))",
      },
      {
        src: quantumCustodyAsset2,
        alt: "quantumCustody-2",
        width: { xs: "84%", sm: "60%", md: "74%", lg: "74%", xl: "54%" },
        zIndex: 7,
        position: { right: { xs: "-18%", sm: "-5%", md: "-18%", lg: "-18%", xl: "5%" }, bottom: { xs: "-35%", sm: "-44%", md: "-54%", lg: "-54%", xl: "-54%" } },
        transition: "all 0.5s ease",
        hoverTransform: "translateY(-6px) scale(1.05)",
        hoverFilter:
          "brightness(1.2) drop-shadow(0px 0px 15px rgba(255, 255, 255, 0.35))",
      },
    ],
  },
  {
    id: "artstake",
    title: "artstake",
    subtitle: "NFT Platform for art",
    link: PORTFOLIO_LINKS.artstake,
    background:
      "linear-gradient(180deg, #141C4F 30%, rgba(198, 198, 201, 0.4) 70%)",
    titleShadow: "0 2px 10px rgba(0,0,0,0.5)",
    titleColor: "#FFFFFF",
    subtitleColor: "#D2DAFF",
    assets: [
      {
        src: artstakeAsset1,
        alt: "artstake-1",
        width: { xs: "92%", md: "62%", lg: "62%", xl: "50%" },
        zIndex: 3,
        position: { left: { xs: "5%", md: "5%", lg: "5%", xl: "10%" }, bottom: { xs: "-15%", md: "-15%", lg: "-15%", xl: "-20%" } },
        transition: "all 0.4s ease",
        hoverTransform: "translateY(-10px)",
        hoverFilter:
          "brightness(1.2) drop-shadow(0px 0px 20px rgba(169, 134, 251, 0.4))",
      },
      {
        src: artstakeAsset2,
        alt: "artstake-2",
        width: { xs: "36%", md: "28%", lg: "28%", xl: "22%" },
        zIndex: 4,
        position: { right: { xs: "18%", md: "18%", lg: "18%", xl: "30%" }, bottom: { xs: "-15%", md: "-15%", lg: "-15%", xl: "-20%" } },
        transition: "all 0.4s ease",
        hoverTransform: "translateY(-6px)",
        hoverFilter:
          "brightness(1.2) drop-shadow(0px 0px 15px rgba(255, 255, 255, 0.32))",
      },
      {
        src: artstakeAsset3,
        alt: "artstake-3",
        width: { xs: "38%", md: "30%", lg: "30%", xl: "24%" },
        zIndex: 4,
        position: { right: { xs: "-5%", md: "-5%", lg: "-5%", xl: "10%" }, bottom: { xs: "-15%", md: "-15%", lg: "-15%", xl: "-20%" } },
        transition: "all 0.4s ease",
        hoverTransform: "translateY(-6px)",
        hoverFilter:
          "brightness(1.2) drop-shadow(0px 0px 15px rgba(255, 255, 255, 0.32))",
      },
    ],
  },
  {
    id: "nmk-creative-hub",
    title: "nmk creative hub",
    subtitle: "marketing agency",
    link: PORTFOLIO_LINKS.nmkCreativeHub,
    background: "#020203",
    bgImage: nmkCreativeHubBG,
    titleColor: "#002B41",
    titleShadow: "0 0 10px rgba(49, 212, 132, 0.35)",
    subtitleColor: "#002B41",
    assets: [
      {
        src: nmkCreativeHubAsset,
        alt: "NMK Creative Hub",
        width: { xs: "100%", sm: "67%", md: "72%", lg: "82%", xl: "62%" },
        zIndex: 4,
        position: { right: { xs: "0%", sm: "17%", md: "10%", lg: "10%", xl: "15%" }, bottom: { xs: "-2%", sm: "-14%", md: "-36%", lg: "-22%", xl: "-20%" } },
        transition: "all 0.4s ease-in-out",
        hoverTransform: "translateY(-5px)",
        hoverFilter:
          "brightness(1.2) drop-shadow(0 0 15px rgba(255, 255, 255, 0.3))",
      },
    ],
  },
  {
    id: "connections-ai",
    title: "connections ai",
    subtitle: "Events search",
    link: PORTFOLIO_LINKS.connectionsAi,
    background: "#9E92FF",
    bgImage: connectionsAiBG,
    bgImageOpacity: 0.3,
    titleColor: "#FFFFFF",
    subtitleColor: "#FFFFFF",
    assets: [
      {
        src: connectionsAiAsset,
        alt: "Connections AI",
        width: { xs: "85%", sm: "65%", md: "72%", lg: "74%", xl: "52%" },
        zIndex: 6,
        position: { right: { xs: "-8%", md: "-5%", lg: "-4%", xl: "10%" }, bottom: { xs: "-74%", sm: "-92%", md: "-82%", lg: "-82%", xl: "-80%" } },
        transition: "all 0.5s ease",
        hoverTransform: "scale(1.05)",
        hoverFilter: "brightness(1.06)",
      },
    ],
  },
  {
    id: "wishinwell",
    title: "wishinwell",
    subtitle: "Social donor app",
    link: PORTFOLIO_LINKS.wishinwell,
    headerAlign: "center",
    background: "#f4fbfb",
    bgImage: wishinwellBG,
    titleColor: "#1C9977",
    subtitleColor: "#2B2A2F",
    assets: [
      {
        src: wishinwellAsset,
        alt: "Wishinwell",
        width: { xs: "100%", sm: "67%", md: "58%", lg: "72%", xl: "50%" },
        zIndex: 4,
        position: { left: "50%", bottom: "-12%" },
        transition: "all 0.4s ease",
        idleTransform: "translateX(-50%)",
        hoverTransform: "translateX(-50%) translateY(-4px)",
        hoverFilter: "brightness(1) drop-shadow(0 0 15px rgba(255, 255, 255, 0.35))",
      },
    ],
  },
  {
    id: "drugrep-ai",
    title: "DrugRepAI",
    subtitle: "AI-driven emotion lab",
    link: PORTFOLIO_LINKS.drugrepAi,
    background: "#f6fffa",
    bgImage: drugRepBG,
    overlayGradient:
      "linear-gradient(180deg, rgba(255,255,255,0.92) 0%, rgba(255,255,255,0.88) 100%)",
    titleColor: "#1A563B",
    subtitleColor: "#0B2317",
    assets: [
      {
        src: drugRepAsset1,
        alt: "DrugRep-1",
        width: { xs: "74%", sm: "50%", md: "50%", lg: "64%", xl: "45%" },
        zIndex: 4,
        position: { left: "5%", bottom: { xs: "-10%", md: "-35%", lg: "-20%" } },
        transition: "transform 0.3s ease",
        hoverTransform: "scale(1.05)",
        hoverFilter:
          "brightness(1.06) drop-shadow(0 0 12px rgba(246, 240, 240, 0.35))",
      },
      {
        src: drugRepAsset2,
        alt: "DrugRep-2",
        width: { xs: "56%", sm: "44%", md: "44%", lg: "54%", xl: "40%" },
        zIndex: 4,
        position: { right: "5%", bottom: { xs: "-3%", md: "-45%", lg: "-15%" } },
        transition: "transform 0.3s ease",
        hoverTransform: "scale(1.05)",
        hoverFilter:
          "brightness(1.06) drop-shadow(0 0 12px rgba(246, 240, 240, 0.35))",
      },
    ],
  },
];

export const carouselProjectById = Object.fromEntries(
  projectsData.map((p) => [p.id, p]),
) as Record<string, ProjectData>;

export function getCarouselProjectById(id: string): ProjectData | undefined {
  return carouselProjectById[id];
}
